import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Empty({ projectLabel }) {
  return (
    <>
      <Box
        mt={3}
        mx={2}
        component="img"
        borderRadius={3}
        width="100%"
        maxWidth={400}
        minHeight="258px"
        src="/images/empty-reservations.png"
        alt="Empty reservations"
      />
      <Typography mt={4} maxWidth={520} fontWeight={500} align="center">
        This {projectLabel} often receives items reserved for certain projects. Please select the
        appropriate option below.
      </Typography>
    </>
  );
}
